import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'underscore';
import { map, pipe } from 'rxjs';
import API_URL from '../../utils/api-url-homolog';


@Injectable({
  providedIn: 'root'
})
export class AlertManagementFilterOptionsService {

  constructor(private http: HttpClient) { }

  getAlertWeightListOptions(): any[] {
    return [
      {
        "value": "0-5"
      },
      {
        "value": "5-7"
      },
      {
        "value": "7-9"
      },
      {
        "value": "MAX"
      }
    ]
  }

}

